export default "__VITE_ASSET__CMV7zN3c__"